import type { BlockId, ReportBrief, ReportPreferences } from './types';

export const blockLabels: Record<BlockId, string> = {
  overview: 'Visão geral',
  funnel: 'Engajamento e conversão',
  agreements: 'Acordos e valores',
  objections: 'Objeções e encerramentos',
  handoffs: 'Atendimento humano',
  timing: 'Tempo e tentativas',
  actions: 'Próximos passos',
};
export const templates: {
  id: ReportBrief['focus'];
  title: string;
  description: string;
  prompt: string;
  blocks: BlockId[];
}[] = [
  {
    id: 'closing',
    title: 'Fechamento do mês',
    description: 'Uma visão completa para apresentar resultados.',
    prompt: 'Quero preparar o fechamento mensal.',
    blocks: ['overview', 'funnel', 'agreements', 'objections', 'handoffs', 'timing', 'actions'],
  },
  {
    id: 'agreements',
    title: 'Acordos e resultados',
    description: 'Conversão, valores negociados e oportunidades.',
    prompt: 'Quero analisar os acordos e os valores negociados.',
    blocks: ['overview', 'funnel', 'agreements', 'actions'],
  },
  {
    id: 'engagement',
    title: 'O que move as conversas?',
    description: 'Engajamento, objeções e pontos de atenção.',
    prompt: 'Quero entender o engajamento das negociações.',
    blocks: ['overview', 'funnel', 'objections', 'handoffs', 'timing', 'actions'],
  },
];
export const defaultPreferences: ReportPreferences = {
  remember: true,
  focus: 'closing',
  blocks: templates[0].blocks,
};
export const stages = [
  'Organizando seu pedido',
  'Consultando negociações',
  'Conferindo os indicadores',
  'Construindo os blocos',
  'Finalizando seu relatório',
];
export const isActive = (status: string) => status === 'queued' || status === 'running';
const dateOnly = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export function periodPreset(kind: 'month' | '30days', now = new Date()) {
  if (kind === 'month')
    return {
      start: dateOnly(new Date(now.getFullYear(), now.getMonth() - 1, 1)),
      end: dateOnly(new Date(now.getFullYear(), now.getMonth(), 0)),
    };
  const start = new Date(now);
  start.setDate(start.getDate() - 29);
  return { start: dateOnly(start), end: dateOnly(now) };
}
export const formatPeriod = (brief: Pick<ReportBrief, 'start' | 'end'>) =>
  `${brief.start.split('-').reverse().join('/')} a ${brief.end.split('-').reverse().join('/')}`;
/** UX de demonstração. A restrição real de ferramentas/escopo pertence ao agente no servidor. */
export function inferTemplate(text: string) {
  const normalized = text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  if (/ignore|sql|delete|senha|codigo|receita|piada/.test(normalized)) return undefined;
  if (/acordo|valor|conversao/.test(normalized)) return templates[1];
  if (/engajamento|conversa|objec|humano|tentativa/.test(normalized)) return templates[2];
  if (/relatorio|dashboard|fechamento|resultado|negociac/.test(normalized)) return templates[0];
  return undefined;
}
